var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64669 6.00004C4.93535 6.00004 5.98002 4.95537 5.98002 3.66671C5.98002 2.37804 4.93535 1.33337 3.64669 1.33337C2.35802 1.33337 1.31335 2.37804 1.31335 3.66671C1.31335 4.95537 2.35802 6.00004 3.64669 6.00004Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3133 10H13.3133C14.0466 10 14.6466 10.6 14.6466 11.3333V13.3333C14.6466 14.0667 14.0466 14.6667 13.3133 14.6667H11.3133C10.58 14.6667 9.97998 14.0667 9.97998 13.3333V11.3333C9.97998 10.6 10.58 10 11.3133 10Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.33337H9.78667C11.02 3.33337 11.5933 4.86004 10.6667 5.67337L5.34 10.3334C4.41334 11.14 4.98667 12.6667 6.21334 12.6667H8",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65748 3.66671H3.66518",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3241 12.3333H12.3318",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/Track.83bbbc72a1f32c5413b5d1c1cad6886d.svg";
export { ForwardRef as ReactComponent };